import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=f453d1d2&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=f453d1d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f453d1d2",
  null
  
)

export default component.exports